/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../Configuration';
import { State } from '../../model/State';

// Services
import { AccessProfileServiceProvider } from './service/AccessProfileServiceProvider';
import { AccountServiceProvider } from './service/AccountServiceProvider';
import { CauseServiceProvider } from './service/CauseServiceProvider';
import { CategoryServiceProvider } from "./service/CategoryServiceProvider";
import { AttributeServiceProvider } from "./service/AttributeServiceProvider";
import { OriginServiceProvider } from './service/OriginServiceProvider';
import { CompanyServiceProvider } from './service/CompanyServiceProvider';
import { DomainServiceProvider } from './service/DomainServiceProvider';
import { ProfileServiceProvider } from './service/ProfileServiceProvider';
import { SiteAttachmentServiceProvider } from './service/SiteAttachmentServiceProvider';
import { SiteServiceProvider } from './service/SiteServiceProvider';
import { GuaranteedRestoreTimePolicyServiceProvider } from './service/GuaranteedRestoreTimePolicyServiceProvider';
import { GuaranteedRestoreTimeServiceProvider } from './service/GuaranteedRestoreTimeServiceProvider';

// Components
import { accountListComponent } from './component/AccountList';
import { accountViewComponent } from './component/AccountView';
import { causeListComponent } from './component/CauseList';
import { causeViewComponent } from './component/CauseView';
import { companyListComponent } from './component/CompanyList';
import { companyViewComponent } from './component/CompanyView';
import { siteListComponent } from './component/SiteList';
import { siteViewComponent } from './component/SiteView';
import { guaranteedRestoreTimeListComponent } from './component/GuaranteedRestoreTimeList';
import { guaranteedRestoreTimePolicyListComponent } from './component/GuaranteedRestoreTimePolicyList';
import { guaranteedRestoreTimePolicyViewComponent } from './component/GuaranteedRestoreTimePolicyView';
import { guaranteedRestoreTimeViewComponent } from './component/GuaranteedRestoreTimeView';

angular.module('serfimtic.gmao.organization', ['ui.router', 'ngResource'])
.provider('accessProfileService', AccessProfileServiceProvider)
.provider('accountService', AccountServiceProvider)
.provider('originService', OriginServiceProvider)
.provider('categoryService', CategoryServiceProvider)
.provider('attributeService', AttributeServiceProvider)
.provider('causeService', CauseServiceProvider)
.provider('companyService', CompanyServiceProvider)
.provider('domainService', DomainServiceProvider)
.provider('profileService', ProfileServiceProvider)
.provider('siteAttachmentService', SiteAttachmentServiceProvider)
.provider('siteService', SiteServiceProvider)
.provider('guaranteedRestoreTimeService', GuaranteedRestoreTimeServiceProvider)
.provider('guaranteedRestoreTimePolicyService', GuaranteedRestoreTimePolicyServiceProvider)
.component('accountList', accountListComponent)
.component('accountView', accountViewComponent)
.component('causeList', causeListComponent)
.component('causeView', causeViewComponent)
.component('companyList', companyListComponent)
.component('companyView', companyViewComponent)
.component('siteList', siteListComponent)
.component('siteView', siteViewComponent)
.component('guaranteedRestoreTimeList', guaranteedRestoreTimeListComponent)
.component('guaranteedRestoreTimeView', guaranteedRestoreTimeViewComponent)
.component('guaranteedRestoreTimePolicyList', guaranteedRestoreTimePolicyListComponent)
.component('guaranteedRestoreTimePolicyView', guaranteedRestoreTimePolicyViewComponent)
.config($stateProvider => {
    /** @ngInject */
    $stateProvider
        .state(State.abstractUrlState('gmao.organization', '/organization', ['ADMIN']))

        .state(State.abstractUrlState('gmao.organization.company', '/company'))
        .state(State.componentState('gmao.organization.company.list', 'companyList', '/list',
            'ui.company.list'))
        .state(State.componentState('gmao.organization.company.create', 'companyView', '/create',
            'ui.company.creation'))
        .state(State.componentState('gmao.organization.company.update', 'companyView', '/update/:id',
            'ui.company.update'))

        .state(State.abstractUrlState('gmao.organization.account', '/account'))
        .state(State.componentState('gmao.organization.account.list', 'accountList', '/list', 'ui.account.list'))
        .state(State.componentState('gmao.organization.account.create', 'accountView', '/create',
            'ui.account.creation'))
        .state(State.componentState('gmao.organization.account.update', 'accountView', '/update/:id',
            'ui.account.update'))

        .state(State.abstractUrlState('gmao.organization.site', '/site'))
        .state(State.componentState('gmao.organization.site.list', 'siteList', '/list',
            'ui.site.list'))
        .state(State.componentState('gmao.organization.site.create', 'siteView', '/create',
            'ui.site.creation'))
        .state(State.componentState('gmao.organization.site.update', 'siteView', '/update/:id',
            'ui.site.update', {}, ['ADMIN', 'USER']))

        .state(State.abstractUrlState('gmao.organization.cause', '/cause'))
        .state(State.componentState('gmao.organization.cause.list', 'causeList', '/list',
            'ui.cause.list'))
        .state(State.componentState('gmao.organization.cause.create', 'causeView', '/create',
            'ui.cause.creation'))
        .state(State.componentState('gmao.organization.cause.update', 'causeView', '/update/:id',
            'ui.cause.update'))

        .state(State.abstractUrlState('gmao.organization.grt', '/grt'))
        .state(State.componentState('gmao.organization.grt.list', 'guaranteedRestoreTimeList', '/list',
            'ui.grt.list'))
        .state(State.componentState('gmao.organization.grt.create', 'guaranteedRestoreTimeView', '/create',
            'ui.grt.creation'))
        .state(State.componentState('gmao.organization.grt.update', 'guaranteedRestoreTimeView', '/update/:id',
            'ui.grt.update'))

        .state(State.abstractUrlState('gmao.organization.grtpolicy', '/grt-policy'))
        .state(State.componentState('gmao.organization.grtpolicy.list', 'guaranteedRestoreTimePolicyList', '/list',
            'ui.grtpolicy.list'))
        .state(State.componentState('gmao.organization.grtpolicy.edit', 'guaranteedRestoreTimePolicyView',
            '/edit', 'ui.grtpolicy.edit', {siteId: undefined}));
})
.config(accessProfileServiceProvider => {
    /** @ngInject */
    accessProfileServiceProvider.setResourceUrl(Configuration.ACCESS_PROFILE_PATH);
})
.config(accountServiceProvider => {
    /** @ngInject */
    accountServiceProvider.setResourceUrl(Configuration.ACCOUNT_PATH);
})
.config(causeServiceProvider => {
    /** @ngInject */
    causeServiceProvider.setResourceUrl(Configuration.CAUSE_PATH);
})
.config(originServiceProvider => {
    /** @ngInject */
    originServiceProvider.setResourceUrl(Configuration.ORIGIN_PATH);
})
.config(categoryServiceProvider => {
    /** @ngInject */
    categoryServiceProvider.setResourceUrl(Configuration.CATEGORY_PATH);
})
.config(attributeServiceProvider => {
    /** @ngInject */
    attributeServiceProvider.setResourceUrl(Configuration.ATTRIBUTE_PATH);
})
.config(companyServiceProvider => {
    /** @ngInject */
    companyServiceProvider.setResourceUrl(Configuration.COMPANY_PATH);
})
.config(domainServiceProvider => {
    /** @ngInject */
    domainServiceProvider.setResourceUrl(Configuration.DOMAIN_PATH);
})
.config(profileServiceProvider => {
    /** @ngInject */
    profileServiceProvider.setResourceUrl(Configuration.PROFILE_PATH);
})
.config(siteAttachmentServiceProvider => {
    /** @ngInject */
    siteAttachmentServiceProvider.setResourceUrl(Configuration.SITE_ATTACHMENT_PATH);
})
.config(siteServiceProvider => {
    /** @ngInject */
    siteServiceProvider.setResourceUrl(Configuration.SITE_PATH);
})
.config(guaranteedRestoreTimeServiceProvider => {
    /** @ngInject */
    guaranteedRestoreTimeServiceProvider.setResourceUrl(Configuration.GRT_PATH);
})
.config(guaranteedRestoreTimePolicyServiceProvider => {
    /** @ngInject */
    guaranteedRestoreTimePolicyServiceProvider.setResourceUrl(Configuration.GRT_POLICY_PATH);
});



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/OrganizationModule.js